import validate from 'validate.js';
import cpfValidator from './cpfValidator';
import brDateValidator from './brDateValidator';
import under18YearsValidator from './under18YearsValidator';
import under16YearsValidator from './under16YearsValidator';
import over100YearsValidator from './over100YearsValidator';
import lowestCurrentDateValidator from './lowestCurrentDateValidator';
import numberPhoneValidator from './numberPhoneValidator';

export const registerCustomValidators = () => {
  validate.validators.cpf = cpfValidator;
  validate.validators.brDate = brDateValidator;
  validate.validators.under18Years = under18YearsValidator;
  validate.validators.under16Years = under16YearsValidator;
  validate.validators.over100Years = over100YearsValidator;
  validate.validators.lowestCurrentDate = lowestCurrentDateValidator;
  validate.validators.phone = numberPhoneValidator;
};
